import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Order, OrderStatus } from '@/types';

interface OrderState {
  selectedOrders: string[];
  filters: {
    status?: OrderStatus[];
    date_from?: string;
    date_to?: string;
    search?: string;
  };
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

const initialState: OrderState = {
  selectedOrders: [],
  filters: {},
  sortBy: 'created_at',
  sortOrder: 'desc',
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setSelectedOrders: (state, action: PayloadAction<string[]>) => {
      state.selectedOrders = action.payload;
    },
    toggleOrderSelection: (state, action: PayloadAction<string>) => {
      const orderId = action.payload;
      if (state.selectedOrders.includes(orderId)) {
        state.selectedOrders = state.selectedOrders.filter(id => id !== orderId);
      } else {
        state.selectedOrders.push(orderId);
      }
    },
    clearSelection: (state) => {
      state.selectedOrders = [];
    },
    setFilters: (state, action: PayloadAction<Partial<OrderState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    setSorting: (state, action: PayloadAction<{ sortBy: string; sortOrder: 'asc' | 'desc' }>) => {
      state.sortBy = action.payload.sortBy;
      state.sortOrder = action.payload.sortOrder;
    },
  },
});

export const {
  setSelectedOrders,
  toggleOrderSelection,
  clearSelection,
  setFilters,
  clearFilters,
  setSorting,
} = orderSlice.actions;

export default orderSlice.reducer; 